module.exports = __webpack_public_path__ + "media/images/logo-77f94f5d4581d2af3a5f76a943754920.svg";